import React from 'react';

export default function(Component, breakpoint = 1200) {
  return class withScreenCheck extends React.Component {
    static displayName = `withScreenCheck(${Component.displayName})`;
    static propTypes = {};
    static defaultProps = {};
    /**
     * @constructor
     * @param {Object} props
     */
    constructor(props) {
      super(props);

      this.getCurrentScreen = this.getCurrentScreen.bind(this);
      this.updateSize = this.updateSize.bind(this);

      this.state = {
        currentScreen: this.getCurrentScreen(),
      };
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateSize);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateSize);
    }

    shouldComponentUpdate(nextProps, nextState) {
      return nextState.currentScreen !== this.state.currentScreen;
    }

    // For the moment, we just have 'mobile' and 'desktop' but we can easily extend the component to use an array of breakpoints
    getCurrentScreen() {
      const currentWidth = window.innerWidth;
      if (currentWidth < breakpoint) {
        return 'mobile';
      } else {
        return 'desktop';
      }
    }

    updateSize() {
      this.setState({
        currentScreen: this.getCurrentScreen(),
      });
    }

    /**
     * @override
     */
    render() {
      return <Component {...this.props} screen={this.state.currentScreen} />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/hoc/withScreenCheck.js